export class RenewalOtherOccupant {
    constructor (
        public ResidentOtherOccupantsKey: number = null,
        public ResidentKey: number = null,
        public Name: string = '',
        public BirthYear: number = null,
        public FromDB: boolean = false,

    ) { }
}
